import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["nonce", "signed"]
  static values = {
    challenge: String,
    signed: String
  }

  connect() {
    this.solve()
  }

  async solve() {
    const challenge = this.challengeValue
    let nonce = 0

    while (true) {
      const candidate = challenge + nonce.toString()
      const hash = await this.sha256(candidate)

      if (hash.startsWith("00")) {
        this.nonceTarget.value = nonce.toString()
        break
      }
      nonce++

      // Yield to browser every 1000 iterations to keep UI responsive
      if (nonce % 1000 === 0) {
        await new Promise(resolve => setTimeout(resolve, 0))
      }
    }
  }

  async sha256(message) {
    const msgBuffer = new TextEncoder().encode(message)
    const hashBuffer = await crypto.subtle.digest("SHA-256", msgBuffer)
    const hashArray = Array.from(new Uint8Array(hashBuffer))
    return hashArray.map(b => b.toString(16).padStart(2, "0")).join("")
  }
}
